import { getDocs, query, where, collection, documentId } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { db } from "../../firebase";
import "./PoomReportsDetail.css";


const PoomReportFromDetail = () => {
  const location = useLocation();
  const { reporting } = location.state;
  const { reportedFrom } = location.state;
  const { reason } = location.state;
  const { pid } = location.state;
  const { chatDocId } = location.state;
  const { commentId } = location.state;
  const [reportFromDetail, setReportFromDetail] = useState([]);
  const [reportingDetail, setReportingDetail] = useState([]);
  const [reportedComment, setReportedComment] = useState([]);
  const [reportedChat, setReportedChat] = useState([]);

  useEffect(() => {
    const getPoomReportDetail = async () => {
      const reportedFromCol = query(collection(db, "users"), where("uid", "==", reportedFrom));
      const reportingFromCol = query(collection(db, "users"), where("uid", "==", reporting));
      const reportedCommentCol = query(collection(
        db,
        `poomProducts/${pid}/comments/`),
        where(documentId(), "==", commentId)
      );
      const reportedChatCol = query(collection(
        db,
        'chatrooms'
      ), where(documentId(), "==", chatDocId))
      const poomReportingDetail = await getDocs(reportingFromCol);
      const poomReportedFromDetail = await getDocs(reportedFromCol);
      const poomReportedCommentDetail = await getDocs(reportedCommentCol);
      const poomReportedChatDetail = await getDocs(reportedChatCol);
      try {
        setReportFromDetail(
          poomReportedFromDetail.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
        );
        setReportingDetail(
          poomReportingDetail.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
        )
        setReportedComment(
          poomReportedCommentDetail.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
        );
        setReportedChat(
          poomReportedChatDetail.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id
          }))
        );
      } catch (error) {
        console.log(error);
      }
    };
    getPoomReportDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-[1000px] mx-auto my-6 p-4">
      {reportFromDetail.map((data) => {
        return (
          <>
            <h2 className="font-bold">Reporter: {data.fullName}</h2>
            <h2>Email: {data.email}</h2>
          </>
        );
      })}
      {reportingDetail.map((data) => {
        return (
          <div className="pt-1">
            <h2 className="font-bold">Reporting: {data.fullName}</h2>
            <h2>Email: {data.email}</h2>
            <h2 className="pt-1 font-bold">
              Reason: <span className="text-red-800">{reason}</span>
            </h2>
          </div>
        );
      })}
      {reportedComment.map((data) => {
          return (
            <>
              <div className="pt-1 pb-4">
                <h2 className="font-bold">Poom Product ID:{' '}
                <span className="font-normal">{pid}</span></h2>
              </div>
              <div className="commentBox">
                <h2 className="font-bold">
                  {data.fullName}'s Comment at{" "}
                  {data.datePosted.toDate().toDateString()} on{" "}
                  {data.datePosted.toDate().toLocaleTimeString("en-US")}:{" "}
                  <span className="text-red-800">{data.comment}</span>
                </h2>
              </div>
            </>
          );
      })}
      {reportedChat.map((data) => {
        return (
          <>
            <h2 className='pt-1 font-bold'>
                Chat Doc ID: {' '}
                <span className='font-normal'>
                  {chatDocId}
                </span>
            </h2>
            <div class="grid grid-cols-4 flex pt-6">
              <div class="self-center">
                <h2 className="font-bold">Reported Chatroom:</h2>
              </div>
              <div className="chatBox">
              {data.messages.map((message) => {
                return (
                  <>
                    <h2 className="font-bold">
                      {message.message[0].user.name}:{" "}
                      <span className="text-red-800">
                        {message.message[0].text}
                      </span>
                    </h2>
                  </>
                );
              })}
            </div>
          </div>
        </>
        );
      })
      }
    </div>
  );
}

export default PoomReportFromDetail;
